import React, { useState, useEffect } from "react";
import Container from "@mui/material/Container";
import { Box, Grid, Typography } from "@mui/material";
import "../../utils/styles/Home/Clientes/ClientesStyles.scss";
import logorepsol from "../../utils/img/Logos/Repsol.png";
import logoSolGas from "../../utils/img/Logos/Logo-Solgas.png";
import logoprimax from "../../utils/img/Logos/logo-primax.png";

const ClientesBar = () => {
  const logos = [logorepsol, logoSolGas, logoprimax];
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMobile) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % logos.length);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [isMobile]);

  return (
    <Box>
      <Box textAlign="center">
        <Typography className="titleClientes">Nuestros Clientes</Typography>
      </Box>
      <Box
        style={{
          background: "#d3d3d36e",
          padding: "30px 0",
        }}
      >
        <Container>
          <Grid container spacing={3} justifyContent="center">
            <Grid item md={6} xs={10} sm={8}>
              <Box className="ContenedorImgClientes" style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "150px" }}>
                {isMobile ? (
                  <img
                    src={logos[currentIndex]}
                    className="imgclients"
                    style={{ maxWidth: "80%", height: "auto", transition: "opacity 0.5s ease-in-out" }}
                    alt="Cliente"
                  />
                ) : (
                  logos.map((logo, index) => (
                    <img key={index} src={logo} className="imgclients" style={{ maxWidth: "33%", height: "auto" }} alt="Cliente" />
                  ))
                )}
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default ClientesBar;